import { Modal } from '@roo/roo';
import React, { ComponentProps, FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './SubtleAlertModal.module.scss';

const DefaultConfirmCountdown = 10;

type SubtleAlertModalProps = Partial<
    Pick<ComponentProps<typeof Modal>, 'visible' | 'onConfirm'>
> & {
    /** 总倒计时（秒） */
    countdown?: number;
};

/**
 * 弱提示弹窗
 */
const SubtleAlertModal: FC<SubtleAlertModalProps> = ({
    visible = false,
    countdown = DefaultConfirmCountdown,
    onConfirm = () => undefined,
}) => {
    const [confirmCountdown, setConfirmCountdown] = useState<number>(0);

    /**
     * 将秒数转换为时分秒格式
     */
    const formatCountdown = (totalSeconds: number): string => {
        if (totalSeconds <= 0) return '';

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (hours > 0) {
            return `${hours}小时${minutes}分${seconds}秒`;
        }
        if (minutes > 0) {
            return `${minutes}分${seconds}秒`;
        }
        return `${seconds}秒`;
    };

    useEffect(() => {
        setConfirmCountdown(countdown);
        const timer = setInterval(() => {
            setConfirmCountdown(ct => {
                if (ct <= 0) {
                    clearInterval(timer);
                    return 0;
                }

                return ct - 1;
            });
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [countdown]);

    return (
        <Modal
            closable={false}
            visible={visible}
            title="客户端升级提醒"
            showCancelButton={false}
            onConfirm={onConfirm}
            confirmText={`我确认${
                confirmCountdown ? ` ( ${formatCountdown(confirmCountdown)} )` : ''
            }`}
            confirmButtonProps={{ disabled: confirmCountdown > 0 }}
        >
            <div className={classNames(styles.main)}>
                <div className={classNames(styles.bold)}>尊敬的美团商家：</div>

                <div>
                    <span className={classNames(styles.danger)}>
                        2024&nbsp;年&nbsp;11&nbsp;月&nbsp;1&nbsp;日起，平台将停止对美团外卖商家端&nbsp;5.0.1&nbsp;以下版本的维护，并将于&nbsp;2024&nbsp;年&nbsp;11&nbsp;月&nbsp;15&nbsp;日下线相关版本。
                    </span>
                    <span>
                        平台停止维护相关版本可能会导致商家端的部分系统功能不可用、甚至无法登陆商家端等问题。
                    </span>
                    <span className={classNames(styles.bold, styles.danger)}>
                        请商家及时关注并更新版本或系统等，因此可能产生的经营影响等问题由商家自行承担。
                    </span>
                </div>

                <div>
                    <span>
                        请您收到本通知后，及时下载&nbsp;5.0.1&nbsp;以上版本美团外卖商家端登录使用，新版本商家端不支持电脑&nbsp;XP&nbsp;系统，请先确保将电脑系统升级到
                        <span className={classNames(styles.danger)}>
                            &nbsp;Win7&nbsp;及以上系统
                        </span>
                        版本后再
                        <span className={classNames(styles.danger)}>
                            升级外卖商家端&nbsp;5.0.1&nbsp;以上版本&nbsp;
                        </span>
                        <a href="https://waimaie.meituan.com/gw/version/pc/download">
                            https://waimaie.meituan.com/gw/version/pc/download
                        </a>
                        。
                    </span>
                </div>

                <div>
                    给您带来的不便，敬请谅解，如有疑问可联系客服。为保证您的正常经营，请您及时下载并更新系统。
                </div>
            </div>
        </Modal>
    );
};

export default SubtleAlertModal;
export { SubtleAlertModal };
